export const getViewportWidth = (): number => {
    return window.document.documentElement && window.document.documentElement.clientWidth
        ? Math.max(window.document.documentElement.clientWidth, window.innerWidth || 0)
        : window.innerWidth || 0;
};
